import React, { useCallback, useEffect, useState } from 'react';
import getCurrentTime from 'utils';
import Grid from './components/grid';
import { ASSESSMENTS } from '../../../config/constants';

let answerTimer = null;

function SymmetryGrid({
  cells = {},
  isSymmetrical = null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  recordResult = () => {},
  timed = false,
  debug = false,
  trial,
  displayResult = false,
}) {
  const [startTime] = useState(getCurrentTime);
  const [answered, setAnswered] = useState(false);
  const [answer, setAnswer] = useState({});
  const [timeExpired, setTimeExpired] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const submitResults = useCallback(
    (response) => {
      recordResult({
        startTs: startTime,
        endTs: getCurrentTime(),
        result: response,
        trial,
      });
    },
    [recordResult, startTime, trial]
  );

  const handleAnswer = useCallback(
    (response) => {
      if (answerTimer) {
        clearTimeout(answerTimer);
        answerTimer = null;
      }
      setAnswered(true);
      setAnswer({
        value: response,
        time: getCurrentTime(),
      });
      if (displayResult) {
        setTimeout(() => {
          submitResults(response);
        }, 2000);
      } else {
        submitResults(response);
      }
    },
    [displayResult, submitResults]
  );

  useEffect(() => {
    if (timed && !initialized) {
      setInitialized(true);
      answerTimer = setTimeout(() => {
        if (answerTimer) {
          answerTimer = null;
          setTimeExpired(true);
          handleAnswer('timeout');
        }
      }, ASSESSMENTS.SYMMETRY_GRID_INTERVAL);
    }
  }, [answered, initialized, handleAnswer, timed, setTimeExpired]);

  return (
    <div className="d-flex flex-column justify-content-center m-3">
      <div className="m-auto">
        <Grid handleAnswer={handleAnswer} cells={cells} timedOut={timeExpired} />
        {answered && displayResult && (
          <div>
            {!timeExpired && (
              <div className="d-flex justify-content-center mb-4">
                {`Your answer is ${answer.value === isSymmetrical ? 'correct' : 'incorrect'}`}
              </div>
            )}
            {timeExpired && (
              <div className="d-flex justify-content-center mb-4">
                You did not respond in the allotted time. This result will be marked as incorrect.
              </div>
            )}
            {debug && (
              <>
                <hr className="mt-4" />
                <div className="d-flex mt-2">{`startTime:  ${startTime}`}</div>
                <div className="d-flex">{`answerTime:  ${answer.time}`}</div>
                <div className="d-flex">
                  <b>
                    <u>{`elapsed:  ${(answer.time - startTime) / 1000} seconds`}</u>
                  </b>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default SymmetryGrid;
